module.exports = __webpack_public_path__ + "img/logo-min.1a70e163.png";